/** * @file FormNotice */
<template>
  <p class="notice"><slot /></p>
</template>

<script>
export default {}
</script>
